import pageBuilder from '@blaze-cms/plugin-page-builder-fe';
import gtm from '@blaze-cms/plugin-gtm-fe';
import chart from '@blaze-cms/plugin-chart';
import googleMaps from '@blaze-cms/plugin-google-maps-fe';
import previewFe from '@blaze-cms/plugin-preview-fe';
import authFe from '@blaze-cms/plugin-auth-fe';
import structuredDataFe from '@blaze-cms/plugin-structured-data-fe';
import translationFe from '@blaze-cms/plugin-translation-fe';

const plugins = new Map();
plugins.set(translationFe, {});
plugins.set(pageBuilder, {});
plugins.set(gtm, {});
plugins.set(chart, {});
plugins.set(googleMaps, {});
plugins.set(previewFe, {});
plugins.set(authFe, {});

plugins.set(structuredDataFe, {
  authenticatedBotHeaders: ['x-amzn-waf-googlebot']
});

const apollo = {
  uri: process.env.BLAZE_GRAPHQL_URI,
  loadEntitiesInBrowser: false
};

export default { plugins, apollo };
